import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import ClientDao from '@/interfaces/client/Client.dao'
import ClientDto from '@/interfaces/client/Client.dto'
import ClientAbbaDao from '@/interfaces/client/ClientAbba.dao'
import ClientsDao from '@/interfaces/client/Clients.dao'
import ClientAbbaDto from '@/interfaces/client/ClientAbba.dto'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class ClientService extends ApiService {
    async getClients(params?: IRequestParameters): Promise<[ClientsDao[], PageNumberPagination] | null> {
        return this.request<undefined, [ClientsDao[], PageNumberPagination] | null>(
            'GET',
            '/clients',
            params,
            undefined,
            undefined,
            'getClients',
        ).catch(() => null)
    }

    async getClientsAbba(params?: IRequestParameters): Promise<[ClientAbbaDao[], PageNumberPagination] | null> {
        return this.request<undefined, [ClientAbbaDao[], PageNumberPagination] | null>(
            'GET',
            '/clients/abba',
            params,
            undefined,
            undefined,
            'getClientsAbba',
        ).catch(() => null)
    }

    async getClient(clientId: number): Promise<ClientDao | null> {
        return this.request<undefined, ClientDao>(
            'GET',
            `/clients/${clientId}`,
            undefined,
            undefined,
            undefined,
            'getClient',
        ).catch(() => null)
    }

    async createClientAbba(clientDto: ClientAbbaDto): Promise<ClientAbbaDao | null> {
        return this.request<ClientAbbaDto, ClientAbbaDao>(
            'POST',
            `/clients/abba`,
            undefined,
            clientDto,
            undefined,
            'createClientAbba',
        ).catch(() => null)
    }
    async createClient(clientDto: ClientDto): Promise<ClientDao | null> {
        return this.request<ClientDto, ClientDao>(
            'POST',
            `/clients`,
            undefined,
            clientDto,
            undefined,
            'createClient',
        ).catch(() => null)
    }

    async updateClient(clientDto: ClientDto): Promise<ClientDao | null> {
        return this.request<ClientDto, ClientDao>(
            'PUT',
            `/clients`,
            undefined,
            clientDto,
            undefined,
            'updateClient',
        ).catch(() => null)
    }
}
